import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import { CircularProgress } from '@mui/material';
import React from 'react';
import ReduxLanguage from '../ReduxLanguage';

export interface ICsvConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filename: string;
  isLoading: boolean;
}

export class CsvConfirmationModal extends React.Component<ICsvConfirmationModalProps> {

  public render() {
    const { open, onClose, onConfirm, filename, isLoading } = this.props;

    return (
      <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Warning style={{ color: '#ff9800', fontSize: 28 }} />
            <Typography variant="h6">
              <ReduxLanguage languageKey="mks.confirmImportTitle" />
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box style={{ marginBottom: 16 }}>
            <Typography variant="body1" style={{ marginBottom: 16 }}>
              <ReduxLanguage languageKey="mks.confirmImportMessage" />
            </Typography>
            <Typography variant="body2" style={{ fontWeight: 'bold', color: '#666' }}>
              <ReduxLanguage languageKey="mks.fileName" />: {filename}
            </Typography>
          </Box>
          
          <Box style={{ 
            backgroundColor: '#fff3cd', 
            border: '1px solid #ffeaa7', 
            borderRadius: 4, 
            padding: 16,
            marginTop: 16
          }}>
            <Typography variant="body2" style={{ color: '#856404', fontWeight: 'bold' }}>
              <ReduxLanguage languageKey="mks.warningMessage" />
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            <ReduxLanguage languageKey="forms.cancel" />
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="primary"
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : undefined}
          >
            <ReduxLanguage languageKey="mks.confirmImport" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default CsvConfirmationModal;
